// Default (no Time Period applied) header + tooltip copy — the existing "(LTM)" wording is
// literally true only when the strip's rolling last-12-months window is in effect.
export const TRANSACTIONS_HEADER_DEFAULT = 'Transactions (LTM)';
export const TRANSACTIONS_TOOLTIP_DEFAULT =
    'Total transactions over the running last 12 months, updated on a rolling basis to reflect the most recent period.';
export const MISSING_DAYS_HEADER_DEFAULT = 'Missing Days (LTM)';
export const MISSING_DAYS_TOOLTIP_DEFAULT = 'Number of days with no data available in the running last 12 months.';

// Once a Time Period range is applied, "(LTM)" is no longer true — drop it from the header and
// name the applied window in the tooltip instead.
export const TRANSACTIONS_HEADER_RANGE_APPLIED = 'Transactions';
export const MISSING_DAYS_HEADER_RANGE_APPLIED = 'Missing Days';

export const buildTransactionsRangeTooltip = (startMonthDisplay: string, endMonthDisplay: string): string =>
    `Total transactions between ${startMonthDisplay} and ${endMonthDisplay}.`;
export const buildMissingDaysRangeTooltip = (startMonthDisplay: string, endMonthDisplay: string): string =>
    `Number of days with no data available between ${startMonthDisplay} and ${endMonthDisplay}.`;
